// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";
import { i18n } from "../main";
import NotFound from "@/components/NotFound.vue";
import featureImage from "@/assets/logo/hk-blue-squar-logo.jpg"

const routes = [
  {
    name: "HomePage",
    path: "",
    component: () => import("@/views/HomePage"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      img_url: featureImage,
      keywords: "Front Desk hotel software, Hotel Software, Hotel guest management system, Hotel front office Software, Front desk software for Hotel, Hotelsoftware online, Hotel management Platform, Motel management System, Hotel Operating System, hotel system software, cloud based hotel software, hotel software management, best hotel front desk software, Hotel front desk System, Hotel monitoring, Software for hotels, Hospitality Management app, Hotel software solutions, Hotel Check in system software, housekeeping hotel software, hospitality management platform, hotel pms integration solution, hotel check-in software, hospitality operations software, cloud based hotel management software,Hotel, hotelkey, Hospitality, Hospitality Technology",
      description: "All-in-one cloud-based system for your operations. Trusted by five enterprises and over 12,500 hotels.",
      title: "HotelKey: Next Generation Hospitality Management Platform"
    },
  },

  {
    path: '/sitemap',
    beforeEnter() {
      window.location.href = '/sitemap.xml';
    }
  },
  

  // {
  //   name: 'HomePage',
  //   path: '',
  //   component: () => import('@/views/HomePage'),
  //   meta: {
  //     darkMode: 'HK-Black',
  //     mobileMode: 'mob-white',
  //     logo_url: 'hk_white_logo.svg',
  //     img_url: '',
  //      keywords: '',
  //      title:''
  //   },
  // },
  // {
  //   name: "PropertyManagement",
  //   path: "/property-management",
  //   component: () => import("@/views/PropertyManagement"),
  //   meta: {
  //     darkMode: "HK-Black",
  //     mobileMode: "mob-white",
  //     logo_url: "hk_white_logo.svg",
  //     description: "",
  //     // img_url:'',
  //     //  keywords:'',
  //     //  title:''
  //   },
  // },
  // {
  //   name: "HkServices",
  //   path: "/services",
  //   component: () => import("@/views/HkServices"),
  //   meta: {
  //     darkMode: "HK-Black",
  //     mobileMode: "mob-white",
  //     logo_url: "hk_white_logo.svg",
  //     description: "",
    
  //   },
  // },
  // {
  //   name: "AfricaPage",
  //   path: "/africa",
  //   component: () => import("@/views/AfricaPage"),
  //   meta: {
  //     darkMode: "HK-Black",
  //     mobileMode: "africa",
  //     logo_url: "hk_white_logo.svg",
  //     description: "",
  //     // img_url:'',
  //     //  keywords:'',
  //     //  title:''
  //   },
  // },
  {
    name: "NewsBlogs",
    path: "/news-blogs",
    component: () => import("@/views/about-us/NewsBlogs"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "HkNews",
    path: "/news-blogs/news",
    component: () => import("@/views/about-us/HkNews"),
    meta: {
      darkMode: "HK-Black",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "HkBlogs",
    path: "/news-blogs/blogs",
    component: () => import("@/views/about-us/HkBlogs"),
    meta: {
      darkMode: "HK-Black",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },

  {
    name: "IsmsPolicy",
    path: "/isms-policy",
    component: () => import("@/views/about-us/IsmsPolicy"),
    meta: {
      darkMode: "HK-Black",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },

  {
    name: "HkTestimonials",
    path: "/testimonials",
    component: () => import("@/views/about-us/HkTestimonials"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },

  {
    name: "BlogDetails",
path: '/blog-details-:slug',
    component: () => import("@/views/about-us/BlogDetails"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "IndependentNews",
    path: "/independent-news",
    component: () => import("@/views/about-us/IndNews"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "EnterpriseNews",
    path: "/enterprise-news",
    component: () => import("@/views/about-us/EnterpriseNews"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },

 
  {
    name: "HkCompany",
    path: "/company",
    component: () => import("@/views/about-us/HkCompany"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
 

  {
    name: "FrontDesk",
    path: "/front-desk",
    component: () => import("@/views/pms/FrontDesk"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-product",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "LostFound",
    path: "/lost-found",
    component: () => import("@/views/pms/LostFound"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-product",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "GuestPad",
    path: "/Guest-pad-app",
    component: () => import("@/views/pms/GuestPad"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-product",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "ManagerApp",
    path: "/manager-app",
    component: () => import("@/views/pms/ManagerApp"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-product",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "SystemIntegrations",
    path: "/system-integrations",
    component: () => import("@/views/pms/SystemIntegrations"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-product",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },

  {
    name: "CorporateRatesBilling",
    path: "/corporate-rates-billing",
    component: () => import("@/views/pms/CorporateRatesBilling"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-product",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "GroupsManagement",
    path: "/groups-management",
    component: () => import("@/views/pms/GroupsManagement"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-product",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "HkReports",
    path: "/reports",
    component: () => import("@/views/pms/HkReports"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-product",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "HousekeepingMaintenance",
    path: "/housekeeping-maintenance",
    component: () => import("@/views/pms/HousekeepingMaintenance"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-product",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "PaymentsAutomation",
    path: "/payments-automation",
    component: () => import("@/views/pms/PaymentsAutomation"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-product",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "PropertyAdministration",
    path: "/property-administration",
    component: () => import("@/views/pms/PropertyAdministration"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-product",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "TheEnterprise",
    path: "/enterprise",
    component: () => import("@/views/TheEnterprise"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },

  {
    name: "RequestADemo",
    path: "/contact-team",
    component: () => import("@/views/contacts/RequestADemo"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "HkCareers",
    path: "/careers",
    component: () => import("@/views/about-us/HkCareers"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },

  // products
  {
    name: "PropertyManagementSystem",
    path: "/property-management-system",
    component: () => import("@/views/pms/PropertyManagementSystem"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-product",
      logo_url: "hk_white_logo.svg",
      description:"A user-intuitive, customizable property management platform with efficient workflows, automated reporting, and increased guest satisfaction.",
      img_url: "frontdesk.webp",
      keywords:"PMS for independent properties, PMS system for hotels, PMS for hotels, Hotel Software PMSProperty Management System, PMS, Hotel Management Software, Hospitality Software, Property Software, Hotel PMS, Hospitality Management System, Hotel Operations Software, Property Operations System, Front Desk Software, Reservation System, Booking Management Software, Hotel Administration Software, Property Automation System, Guest Management Software, Revenue Management System, Housekeeping Management Software, Hospitality Technology, Hotel Software Solutions, Property Administration Platform, Integrated Hotel Management System, Room Inventory Management, Hotel Front Office System, Hospitality Property Software, Property Revenue Optimization, Cloud-Based Property Management System for Hotels, Hotel Property Management System with Channel Manager Integration, System with Channel Manager Integration, Integrated PMS and CRM Solution for Hotel Chains, Modern Property Automation System, Centralized Hotel Operations Management Software with Multi-Property Support, User-Friendly Property Management System for Bed and Breakfasts",
      title: "HotelKey: Property Management System",
    },
    // metaInfo: {
    //   title: '',
    //   meta: [
    //     {
    //       name: 'description',
    //        content: 'A user-intuitive, customizable property management platform with efficient workflows, automated reporting, and increased guest satisfaction.'
    //     },
    //     {
    //       property: 'og:title',
    //       content: 'HotelKey: Property Management System'
    //     },
    //     {
    //       property: 'og:description',
    //        content: 'A user-intuitive, customizable property management platform with efficient workflows, automated reporting, and increased guest satisfaction.'
    //     }
    //   ]
    // },
  },
  {
    name: "RateManagementSystem",
    path: "/rate-management-system",
    component: () => import("@/views/rms/RateManagementSystem"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description:
        "Quickly manage and distribute your rates and inventory all in one place. Automated STR controls, restriction and policy management, auto adjustable pricing and more.",
      img_url: "rms_banner.svg",
      keywords:
        "Rate Management System, RMS, Pricing Software, Revenue Management Tool, Rate Optimization Platform, Rate Control System, Pricing Strategy Software, Rate Setting Tool, Dynamic Pricing System, Revenue Optimization Software, Rate Management System for Hotels and Resorts, Rate Setting, Revenue Tool, Pricing Management, Rate Strategy, Revenue Platform, Pricing System, Rate Analysis, Revenue Control, Cloud-Based Rate Optimization Platform for Vacation Rental Owners, Revenue Management Software with Automated Pricing Recommendations, Pricing Software for Hospitality Businesses with Channel Integration, Rate Setting Tool with Historical Data Analysis Features, Dynamic Rate Management System for Maximizing Profitability, Integrated Revenue Management Solution for Hotel Operations, Pricing Strategy Software for Small and Medium-Sized Hotels",
      title: "HotelKey: Rate Management System",
    },
    // metaInfo: {
    //   title: '',
    //   meta: [

    //     {
    //       property: 'og:title',
    //       content: 'HotelKey: Rate Management System'
    //     },
    //     {
    //       property: 'og:description',
    //        content: 'Quickly manage and distribute your rates and inventory all in one place. Automated STR controls, restriction and policy management, auto adjustable pricing and more.'
    //     }
    //   ]
    // },
  },
  {
    name: "CentralReservationSystem",
    path: "/central-reservation-system",
    component: () => import("@/views/crs/CentralReservationSystem"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description:
        "Experience seamless room distribution across all major OTAs and GDS platforms. Say goodbye to overbookings with real-time inventory sync and comprehensive distribution management tools.",
      img_url: "rate_calendar.webp",
      keywords:
        "Central Reservation System, CRS, Reservation Software, Booking System, Reservation Platform, Hotel Booking Software, Central Booking System, Reservation Management, Hotel Reservation System, Booking Management, Comprehensive Central Reservation System for Hotels and Resorts, Cloud-Based Reservation Software for Hospitality, Integrated Booking Platform with Channel Management Integration, Automated Hotel Reservation System with Real-Time Availability, Centralized Booking Management System for Vacation Rentals, Advanced Reservation Management Software for Independent Hotels, Central Reservation System with Multi-Property Support, User-Friendly Hotel Booking Software with Mobile Compatibility, Reservation Platform with Group Booking, Management Features, Cloud-Based Central Booking System for Bed and Breakfasts, Hotel Reservation Software with Dynamic Pricing",
      title: "HotelKey: Central Reservation System",
    },
  
  },
  // crs menus
  {
    name: "BookingEngine",
    path: "/booking-engine",
    component: () => import("@/views/crs/BookingEngine"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "HkDistribution",
    path: "/distribution",
    component: () => import("@/views/crs/HkDistribution"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "PropertyWebsite",
    path: "/property-website",
    component: () => import("@/views/crs/PropertyWebsite"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "RateCalendar",
    path: "/rate-calendar",
    component: () => import("@/views/crs/RateCalendar"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "FindReserve",
    path: "/find-reserve",
    component: () => import("@/views/crs/FindReserve"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  

  {
    name: "RateAdmin",
    path: "/rate-room-type-admin",
    component: () => import("@/views/crs/RateAdmin"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },

  {
    name: "AutomatedIntegration",
    path: "/automated-str-integration",
    component: () => import("@/views/rms/AutomatedIntegration"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "HkIntegrations",
    path: "/integrations",
    component: () => import("@/views/integrations/HkIntegrations"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description:
        "Choose from 100+ APIs to connect with HotelKey products. Eliminate operational glitches. Streamline workflows like a pro.",
      img_url: "integrations-banner.svg",
      keywords:
        "Hotel Integration Partners, Hospitality Integrations, Hotel API Partners, Property Management Integrations, Hotel Software Partners, Integration Solutions for Hotels, Hospitality Technology Partners, Hotel System Integrations, Property Management System Partners, Hotel Tech Integrations, Hotel API Integration Solutions for Seamless Operations, Hospitality Software Integration Partnerships for Improved Efficiency, Hotel Technology Partnerships for Enhanced Guest Experience, Property Management System Integration Solutions for Hotel Chains, Integrated Technology Solutions for Hotel Operations Management, Hotel Software Integration Partners for Streamlined Front Office Operations, Seamless Integration Solutions for Hotel Booking Systems, Hospitality Technology Partnerships for Revenue Optimization, Property Management System Integration Partners for Enhanced Guest Service, Hospitality Integration Services, Hotel Tech Partners, Property Integration Partners, Hotel API Integration, Hospitality Software Integrations, Hotel System Partners, Property Tech Integrations, Hotel Technology Partners",
      title: "HotelKey Integrations: 100+ Options. One Single Platform",
    },
  },
  {
    name: "CompShopData",
    path: "/comp-shop-data",
    component: () => import("@/views/rms/CompShopData"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "DynamicBarhk",
    path: "/dynamicbar",
    component: () => import("@/views/rms/DynamicBarhk"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "NotificationsRules",
    path: "/notifications-rules",
    component: () => import("@/views/rms/NotificationsRules"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "PolicyManagement",
    path: "/policy-management",
    component: () => import("@/views/rms/PolicyManagement"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "HkSeasons",
    path: "/seasons",
    component: () => import("@/views/rms/HkSeasons"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "SpecialEvents",
    path: "/special-events",
    component: () => import("@/views/rms/SpecialEvents"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "AdvancedRestriction",
    path: "/advanced-restriction-controls",
    component: () => import("@/views/rms/AdvancedRestriction"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  // Bi
  {
    name: "BusinessIntelligence",
    path: "/business-intelligence",
    component: () => import("@/views/bi/BusinessIntelligence"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description:
        "Boost your revenue and operations with real time data. Get insights on operational metrics, hotel trends and generate dynamic reports.",
      img_url: "bi_banner_img.webp",
      keywords:
        "Business Intelligence for Hotels, Hotel Data Insights, Advanced Analytics for Hospitality, Hotel Business Intelligence, Data Analytics for Hotels, HotelKey Analytics, Hotel Performance Metrics, Hospitality Data Analysis, Hotel BI Tools, HotelKey Business Intelligence Platform for Advanced Data Insights, Comprehensive Business Intelligence Solutions for Hotel Industry, Hotel Data Analytics Software with Performance Metrics Tracking, Advanced Data Insights Platform for Hospitality Management, Hotel Business, Intelligence Tools for Revenue Optimization, Cloud-Based Analytics Platform for Hotel Performance Monitoring, Hotel Data Analysis, Software with Predictive Analytics Capabilities, Business Intelligence Solutions for Hotel Revenue Management, HotelKey BI Dashboard for Real-Time Data hotel data, Hotel Business Intelligence Software for Decision-Making Support.",
      title:
        "HotelKey Business Intelligence: Advanced Data Insights for Hotels",
    },
  },
  {
    name: "PortfolioInsights",
    path: "/portfolio-insights",
    component: () => import("@/views/bi/PortfolioInsights"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "PropertyInsights",
    path: "/property-insights",
    component: () => import("@/views/bi/PropertyInsights"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "DynamicReport",
    path: "/dynamic-report",
    component: () => import("@/views/bi/DynamicReport"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "RetailKey",
    path: "/retailkey",
    component: () => import("@/views/retailkey/RetailKey"),
    meta: {
      darkMode: "HK-Retail",
      mobileMode: "mob-white",
      logo_url: "retailkey_logo.svg",
      description:
        "World-class Point-of-Sale solution to manage & run your business smoothly and efficiently. RetailKey provides a user-friendly interface, inventory management, and in-room ordering options.",
      img_url: "register-app.webp",
      keywords:
        '"Point of Sale Solution, Restaurant POS System, Retail Management Software, Hospitality POS Platform Store POS System, Boutique POS Software, Restaurant Operations Solution, Retail Business Management, Hospitality POS Technology, Retail Automation Tool, Advanced POS System for Restaurants, Streamlined Retail Management Software, Boutique POS for Small Businesses, User-Friendly Hospitality POS, Efficient Restaurant Operations Solution, Tailored Retail Automation Tool, Seamless Store POS System, Boutique POS for Sales Management, Restaurant POS for Order Processing, Retail Management Solution for Stores, User-Friendly POS Platform for Hospitality Industry and Restaurants Efficient Restaurant POS System for Streamlining Operations Innovative Retail Management Solution for Stores and Shops Hospitality POS Technology for Efficient Restaurant Operations Tailored Retail Automation Tool for Small Businesses and Boutiques Restaurant Operations Solution for Enhanced Efficiency and Customer Service Seamless Store POS System for Retail Business Management"',
      title: "RetailKey: Intelligent POS System for Hotels and Restaurants",
    },
  },

  {
    name: "TenantKey",
    path: "/tenant-key",
    component: () => import("@/views/tenantkey/TenantKey"),
    meta: {
      darkMode: "hk-tenantKey",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },

  // {
  //     name:'TheRestaurants',
  //     path:'/retailkey',
  //     component:()=> import('@/views/TheRestaurants'),
  //     meta: {
  //         darkMode: 'HK-Retail',
  //       },
  // },
  {
    name: "RegisterApp",
    path: "/register-app",
    component: () => import("@/views/retailkey/RegisterApp"),
    meta: {
      darkMode: "HK-Retail",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "ReportingAnalytics",
    path: "/reporting-analytics",
    component: () => import("@/views/retailkey/ReportingAnalytics"),
    meta: {
      darkMode: "HK-Retail",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "OrderManagement",
    path: "/order-management",
    component: () => import("@/views/retailkey/OrderManagement"),
    meta: {
      darkMode: "HK-Retail",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "OrderTakingApp",
    path: "/order-taking-app",
    component: () => import("@/views/retailkey/OrderTakingApp"),
    meta: {
      darkMode: "HK-Retail",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "KitchenDisplay",
    path: "/kitchen-display",
    component: () => import("@/views/retailkey/KitchenDisplay"),
    meta: {
      darkMode: "HK-Retail",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "EasyPayments",
    path: "/easy-payments",
    component: () => import("@/views/retailkey/EasyPayments"),
    meta: {
      darkMode: "HK-Retail",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "ProductManagement",
    path: "/product-management",
    component: () => import("@/views/retailkey/ProductManagement"),
    meta: {
      darkMode: "HK-Retail",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "HardwareIntegration",
    path: "/hardware-integration",
    component: () => import("@/views/retailkey/HardwareIntegration"),
    meta: {
      darkMode: "HK-Retail",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
 
  {
    name: "InventoryManagement",
    path: "/inventory-management",
    component: () => import("@/views/retailkey/InventoryManagement"),
    meta: {
      darkMode: "HK-Retail",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "VendorsPurchaseManagement",
    path: "/vendors-purchase-management",
    component: () => import("@/views/retailkey/VendorsPurchaseManagement"),
    meta: {
      darkMode: "HK-Retail",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  

  {
    name: "PaymentKey",
    path: "/payment-key",
    component: () => import("@/views/payment-key/PaymentKey"),
    meta: {
      darkMode: "HK-Paymentkey",
      mobileMode: "mob-white",
      logo_url: "paymentkey_logo.svg",
      description:
        "PaymentKey is your property`s single point of contact managing chargebacks, payment processing and 24*7 merchant support.",
      img_url: "pa_banner_img.svg",
      keywords:
        '"Hospitality Merchant Services, Hotel Payment Solutions, Resort Merchant Support, Hospitality Payment Processing, Lodging Payment Management, Hospitality Transaction Services, Hotel Payment Assistance, Hospitality Merchant Support, Resort Financial Services, Lodging Payment Solutions, Payment Solutions, Merchant Support, Financial Services, Payment Processing, Payment Management, Transaction Services, Payment Assistance, Merchant Support, Comprehensive Merchant Services for Hotels and Resorts, Efficient Payment Solutions for Hospitality Industry, Secure Financial Transactions with Hotel Merchant Support, Streamlined Payment Processing Services for Resorts, Professional Payment Management Assistance for Lodgings, Seamless Transaction Processing Solutions for Hospitality Businesses, Reliable Payment Assistance Services for Hotels and Resorts, Expert Merchant, Support for Financial Transactions in the Hospitality Sector, Comprehensive Payment Solutions for Hotels and Resorts, Seamless Payment Assistance for Hospitality Businesses, Secure Financial Services for Hotels and Resorts, Comprehensive Transaction Processing Solutions for Lodgings, Professional Payment Solutions for the Hospitality Industry Expert Merchant Support for Payment Management in Hotels and Resorts Efficient Financial Transactions with Payment Assistance in Hospitality Reliable Merchant Services for Hotels and Resorts Streamlined Payment Solutions for Lodgings Seamless Financial Transactions with Merchant Support in Hospitality Secure Payment Management Services for Hotels and Resorts Expert Financial Services for the Hospitality Sector"',
      title: "PaymentKey: Chargeback Support",
    },
  },
  
  {
    name: "HiltonEnt",
    path: "/hilton",
    component: () => import("@/views/enterprises-page/HiltonEnt"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
    {
    name: "IhgEnt",
    path: "/ihg",
    component: () => import("@/views/enterprises-page/IhgEnt"),
    meta: {
      darkMode: "HK-Retail",
      mobileMode: "mob-white",
      logo_url: "retailkey_logo.svg",
      description: "",
    
    },
  },
  // {
  //   name: "10YearAnniversary",
  //   path: "/10-year-in-hospitality-technology",
  //   component: () => import("@/views/enterprises-page/10YearAnniversary"),
  //   meta: {
  //     darkMode: "HK-Black",
  //     mobileMode: "mob-white",
  //     logo_url: "hk_white_logo.svg",
  //     description: "",
  //     // img_url:'',
  //     //  keywords:'',
  //     //  title:''
  //   },
  // },
  {
    name: "G6Ent",
    path: "/G6",
    component: () => import("@/views/enterprises-page/G6Ent"),
    meta: {
      darkMode: "HK-Black hk-entpage",
      mobileMode: "mob-product",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "TheBoard",
    path: "/the-board",
    component: () => import("@/views/about-us/TheBoard"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
      img_url: "pa_banner_img.svg",
      keywords: "",
      title: "",
    },
  },
  {
    name: "OurOffice",
    path: "/our-office",
    component: () => import("@/views/about-us/OurOffice"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
      img_url: "pa_banner_img.svg",
      keywords: "",
      title: "",
    },
  },
  {
    name: "Event",
    path: "/event",
    component: () => import("@/views/about-us/OurEvent"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
      img_url: "pa_banner_img.svg",
      keywords: "",
      title: "",
    },
  },
  {
    name: "Overviews",
    path: "/Overviews",
    component: () => import("@/views/product-overview/Overviews"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
      img_url: "pa_banner_img.svg",
      keywords: "",
      title: "",
    },
  },


  {
    name: "Region",
    path: "/region",
    component: () => import("@/views/region/RegionMain"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
      img_url: "pa_banner_img.svg",
      keywords: "",
      title: "",
    },
  },

  {
    name: "MarketingMaterials",
    path: "/resources",
    component: () => import("@/views/marketing-materials/MarketingMaterials"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "Download HotelKey's brochures, flyers, and white papers.",
      keywords: "",
      title: "HotelKey: Resources",
    },
  },
  
  {
    name: "industries",
    path: "/industries",
    component: () => import("@/views/industries/IndustriesMain"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
      img_url: "pa_banner_img.svg",
      keywords: "",
      title: "",
    },
  },
 

  {
    name: "terms&conditions",
    path: "/terms&conditions",
    component: () => import("@/components/TermsConditions"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
      img_url: "pa_banner_img.svg",
      keywords: "",
      title: "",
    },
  },

  {
    name: "privacypolicy",
    path: "/privacypolicy",
    component: () => import("@/components/PrivacyPolicy"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
      img_url: "pa_banner_img.svg",
      keywords: "",
      title: "",
    },
  },
  {
    name: "privacy-objectives",
    path: "/privacy-objectives",
    component: () => import("@/components/PrivicyObjectives"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
      img_url: "pa_banner_img.svg",
      keywords: "",
      title: "",
    },
  },
  {
    name: "internal-sales-portal",
    path: "/internal-sales-portal",
    component: () =>
      import("@/views/internal-sales-portal/InternalSalesPortal"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },
  {
    name: "GuestKey",
    path: "/guestkey",
    component: () =>
      import("@/views/guestkey/GuestKey"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "GuestKey is an AI-powered hotel guest experience platform with automated messaging, self-service kiosks, and digital keys to streamline check-in, reduce front desk workload, and enhance guest satisfaction.",
      title: "GuestKey | AI-powered Hotel Guest Experience Platform with Messaging, Kiosks & Digital Keys",
    
    },
  },
  {
    name: "GuestMessaging",
    path: "/guest-messaging",
    component: () => import("@/views/guestkey/guest-messaging"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "GuestKey is an AI-powered hotel guest experience platform with automated messaging, self-service kiosks, and digital keys to streamline check-in, reduce front desk workload, and enhance guest satisfaction.",
      title: "GuestKey | AI-powered Hotel Guest Experience Platform with Messaging, Kiosks & Digital Keys",
    },
  },
  {
    name: "GkWalletkey",
    path: "/walletkey",
    component: () => import("@/views/guestkey/gk-walletkey"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "GuestKey is an AI-powered hotel guest experience platform with automated messaging, self-service kiosks, and digital keys to streamline check-in, reduce front desk workload, and enhance guest satisfaction.",
      title: "GuestKey | AI-powered Hotel Guest Experience Platform with Messaging, Kiosks & Digital Keys",
    },
  },
  {
    name: "GkKiosk",
    path: "/kiosk",
    component: () => import("@/views/guestkey/gk-kiosk"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    },
  },
  // {
  //   name: "ActivityKey",
  //   path: "/activity-key",
  //   component: () =>
  //     import("@/views/activitykey/ActivityKey"),
  //   meta: {
  //     darkMode: "hk-activitykey",
  //     mobileMode: "mob-white",
  //     logo_url: "activitykey.svg",
  //     description: "",
    
  //   },
  // },
  {
    name: "IotKey",
    path: "/iotkey",
    component: () => import("@/views/iotkey/IotKey"),
    meta: {
      darkMode: "hk-iotkey",
      mobileMode: "mob-white",
      logo_url: "iotkey_logo.svg",
      description: "",
    
    },
  },
  {
    name: "EventKey",
    path: "/event-key",
    component: () => import("@/views/eventkey/EventKey"),
    meta: {
      darkMode: "hk-eventkey",
      mobileMode: "mob-white",
      logo_url: "eventkey.svg",
      description:
        "Simplify your event management with our full serviced platform. From Weddings and parties to conferences, we host it all.",
      img_url: "folio-management.jpg",
      keywords: "",
      title: "EventKey: Event Management by HotelKey",
    },
  },
  {
    name: "TrainKey",
    path: "/train-key",
    component: () =>
      import("@/views/trainkey/TrainKey"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },

  {
    name: "Supports",
    path: "/support",
    component: () => import("@/views/contacts/Supports.vue"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },

  {
    name: "HkMigration",
    path: "/hk-ng-migration",
    component: () => import("@/views/migration/HkMigration.vue"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      hideChrome: true,
      title: "System Migration 2026 - HotelKey",
      description:
        "HotelKey is transitioning to a modern browser-based platform. Learn about the migration timeline, support resources, and go-live details for November 15, 2026.",
    },
  },

  // 404 Not Found route (catch-all)
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: NotFound,
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      title: "404 Not Found",
      description: "Page not found.",
    },
  },

  
  {
    name: "EventAdministrationSetup",
    path: "/event-administration-setup",
    component: () =>
      import("@/views/eventkey/EventAdministrationSetup"),
    meta: {
      darkMode: "hk-eventkey",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },

  //EconomyBundle
  {
    name: "EconomyBundle",
    path: "/hk-economy-bundle",
    component: () =>
      import("@/views/economy-bundle/EconomyBundle.vue"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
    
    },
  },

  //WalletKey Pages
  {
    name: "WalletKeyPrivacyPolicy",
    path: "/walletkey/privacy_policy",
    component: () =>
      import("@/views/walletkey/PrivacyPolicy.vue"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
      img_url: "pa_banner_img.svg",
      keywords: "",
      // title: "WalletKey - Privacy Policy",
    },
  },
  {
    name: "WalletKeyFAQ",
    path: "/walletkey/faq",
    component: () =>
      import("@/views/walletkey/FAQ.vue"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
      img_url: "pa_banner_img.svg",
      keywords: "",
      // title: "WalletKey - FAQ",
    },
  },
  {
    name: "WalletKeyTerms",
    path: "/walletkey/terms",
    component: () =>
      import("@/views/walletkey/Terms.vue"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
      img_url: "pa_banner_img.svg",
      keywords: "",
      // title: "WalletKey - Terms & Conditions",
    },
  },
  {
    name: "RoomKeyInAppleWalletFaq",
    path: "/walletkey/room-key-in-apple-wallet-faq",
    component: () =>
      import("@/views/walletkey/RoomKeyInAppleWalletFaq.vue"),
    meta: {
      darkMode: "HK-Black",
      mobileMode: "mob-white",
      logo_url: "hk_white_logo.svg",
      description: "",
      img_url: "pa_banner_img.svg",
      keywords: "",
      // title: "WalletKey - Room Key in Apple Wallet FAQ",
    },
  },

];
const router = createRouter({
  history: createWebHistory("/"),
  routes,
  scrollBehavior() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  },
});

router.beforeEach((to, from, next) => {
  const currentPageUrl = window.location.origin + to.fullPath;

  const defaultTitle = "HotelKey: Next Generation Hospitality Management Platform";
  const defaultDescription = "All-in-one cloud-based system for your operations. Trusted by five enterprises and over 12,500 hotels.";
  const defaultKeywords = "Front Desk hotel software, Hotel Software, Hotel guest management system, Hotel front office Software, Front desk software for Hotel, Hotelsoftware online, Hotel management Platform, Motel management System, Hotel Operating System, hotel system software, cloud based hotel software, hotel software management, best hotel front desk software, Hotel front desk System, Hotel monitoring, Software for hotels, Hospitality Management app, Hotel software solutions, Hotel Check in system software, housekeeping hotel software, hospitality management platform, hotel pms integration solution, hotel check-in software, hospitality operations software, cloud based hotel management software, PMS page : PMS for independent properties, pms system for hotels, pms for hotels, Hotel Software PMS, Hotel, hotelkey, Hospitality, Hospitality Technology";
  const defaultImage = featureImage;

  const metaTags = to.meta || {};
  const title = metaTags.title || defaultTitle;
  const description = metaTags.description || defaultDescription;
  const keywords = metaTags.keywords || defaultKeywords;

  // Ensure image is absolute
  let image = metaTags.img_url || defaultImage;
  if (image && !image.startsWith("http")) {
    image = window.location.origin + image;
  }

  document.title = title;

  // Remove all existing name/property meta tags (excluding charset, viewport, etc.)
  document.querySelectorAll('meta[name], meta[property]').forEach((el) => {
    if (!["viewport", "charset"].includes(el.getAttribute("name"))) {
      el.remove();
    }
  });

  const addMetaTag = (name, content) => {
    if (!content) return;
    const tag = document.createElement("meta");
    tag.setAttribute("name", name);
    tag.setAttribute("content", content);
    document.head.appendChild(tag);
  };

  const addOGTag = (property, content) => {
    if (!content) return;
    const tag = document.createElement("meta");
    tag.setAttribute("property", property);
    tag.setAttribute("content", content);
    document.head.appendChild(tag);
  };

  // --- ✅ Standard Meta Tags ---
  addMetaTag("description", description);
  addMetaTag("keywords", keywords);

  // --- ✅ Open Graph Tags (for Facebook/LinkedIn) ---
  addOGTag("og:title", title);
  addOGTag("og:description", description);
  addOGTag("og:url", currentPageUrl);
  addOGTag("og:image", image);
  addOGTag("og:image:width", "1200");
  addOGTag("og:image:height", "630");
  addOGTag("og:type", "website");
  addOGTag("og:site_name", "HotelKey");

  // --- ✅ Twitter Tags ---
  addMetaTag("twitter:card", "summary_large_image");
  addMetaTag("twitter:site", "@HotelKey"); // Update to actual Twitter handle
  addMetaTag("twitter:title", title);
  addMetaTag("twitter:description", description);
  addMetaTag("twitter:image", image);
  addMetaTag("twitter:url", currentPageUrl);

  // --- Language/Localization ---
  i18n.locale = localStorage.getItem("language") || "en";

  // --- Optional Scroll + Visual UX ---
  const appEl = document.getElementById("app");
  if (appEl) {
    appEl.classList.add("my-bg-class");
    setTimeout(() => {
      appEl.scrollIntoView();
      appEl.classList.remove("my-bg-class");
    }, 1000);
  }

  next();
});

export default router;